import { format } from 'date-fns';

export const COLUMNS = [
	{
		Header: 'ID',
		accessor: 'planConservacionId',
	},
	{
		Header: 'Indicador',
		accessor: 'indicador.sigla',
	},
	{
		Header: 'Exigencia',
		accessor: 'exigencia.sigla',
	},
	{
		Header: 'Fecha Planificada Carga',
		accessor: 'fechaPlanificada',
		Cell: ({ value }) => value ? format(new Date(value), 'dd-MM-yyyy') : '',
	  },
	  {
		Header: 'Fecha Carga de Archivo',
		accessor: 'informesConservacion.fechaCarga',
		Cell: ({ value }) => value ? format(new Date(value), 'dd-MM-yyyy') : '',
	  },
	  {
		Header: 'Fecha Envio Bitácora',
		accessor: 'informesConservacion.fechaInformado',
		Cell: ({ value }) => value ? format(new Date(value), 'dd-MM-yyyy HH:mm:ss') : '',
	  },
	
]
